function initializeResponsiveSlick() {
    // Check window width using `window.innerWidth`
    if ($(window).width() < 1200) {
        // Check if .shopbycategory-slider is not initialized
        if (
            $(".shopbycategory-slider").length &&
            !$(".shopbycategory-slider").hasClass("slick-initialized")
        ) {
            $(".shopbycategory-slider").slick({
                infinite: true,
                speed: 500,
                autoplay: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            spaceBetween: 10,
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            dots: false,
                            arrows: true,
                        },
                    },
                ],
            });
        }

        // Check if .certification-slider is not initialized
        if (
            $(".certification-slider").length &&
            !$(".certification-slider").hasClass("slick-initialized")
        ) {
            $(".certification-slider").slick({
                speed: 500,
                autoplay: true,
                slidesToShow: 4,
                slidesToScroll: 3,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                ],
            });
        }
    } else {
        // Destroy slick if window width is greater than 1200
        if ($(".shopbycategory-slider").hasClass("slick-initialized")) {
            $(".shopbycategory-slider").slick("unslick");
        }
        if ($(".certification-slider").hasClass("slick-initialized")) {
            $(".certification-slider").slick("unslick");
        }
    }
}

// Initialize on page load
initializeResponsiveSlick();

// Reinitialize on window resize
$(window).resize(function () {
    initializeResponsiveSlick();
});
